var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleFilled = function SvgCheckCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "checkCircleFilled_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h22v22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkCircleFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.72 12.653-1.972-1.971a.87.87 0 0 0-.641-.252.87.87 0 0 0-.642.252.869.869 0 0 0-.252.641c0 .26.084.474.252.642l2.613 2.613a.88.88 0 0 0 .641.275.88.88 0 0 0 .642-.275l5.18-5.18a.87.87 0 0 0 .251-.641.87.87 0 0 0-.252-.642.87.87 0 0 0-.642-.252.869.869 0 0 0-.641.252l-4.538 4.538Zm1.283 7.516c-1.268 0-2.46-.24-3.575-.722a9.258 9.258 0 0 1-2.91-1.959 9.257 9.257 0 0 1-1.96-2.91 8.926 8.926 0 0 1-.722-3.575c0-1.268.24-2.46.722-3.575a9.257 9.257 0 0 1 1.96-2.91 9.257 9.257 0 0 1 2.91-1.96 8.926 8.926 0 0 1 3.575-.722c1.268 0 2.46.24 3.575.722a9.257 9.257 0 0 1 2.91 1.96 9.258 9.258 0 0 1 1.96 2.91 8.927 8.927 0 0 1 .721 3.575c0 1.268-.24 2.46-.722 3.575a9.258 9.258 0 0 1-1.959 2.91 9.258 9.258 0 0 1-2.91 1.96 8.927 8.927 0 0 1-3.575.721Z",
    fill: "#40424C"
  }))));
};
export default SvgCheckCircleFilled;